<template>
  <v-container fluid class="section-height soft-grey">
    <v-row no-gutters>
      <Header small :value="'С чем я НЕ Работаю:'"/>
    </v-row>
    <v-row no-gutters>
      <v-list disabled class="title font-weight-light  ma-0 py-0">
        <v-list-item v-for="item in requestNotWork" :key="item" class="soft-grey"
        >
          <v-list-item-icon>
            <v-icon>mdi-circle-small</v-icon>
          </v-list-item-icon>
          <v-list-item-content style="overflow-wrap: anywhere;">
            <v-list-item-title
              class="text-wrap "
              style="overflow-wrap: anywhere;"
            >
              {{ item }}
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-row>
  </v-container>
</template>

<script>
import Header from "@/components/Header";

export default {
  name: "NotWorkWith",
  components : {
    Header
  },
  data() {
    return {
      requestNotWork: [
        'С детьми и подростками младше 18 лет', 'С семейными парами',
        'С химическими зависимостями (наркотики, алкоголь…)',
        'С шоковыми травмами (ситуации насилия, пережитые экстремальные ситуации, катастрофы, военные действия и т.д.) и ПТСР (посттравматическое стрессовое расстройство)',
        'С ментальными расстройствами психотического уровня (бред, галлюцинации, «голоса в голове» и т.д.)'],
    }
  }
}
</script>

<style scoped>

</style>
